var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.731603 11.1741C0.201455 10.6546 0.202363 9.80452 0.721073 9.28616V9.27285L8.71522 1.2842C9.23484 0.751621 10.0742 0.751621 10.6072 1.2842C11.1268 1.80346 11.1268 2.64227 10.6072 3.17484L4.878 8.90007H20.334C21.0668 8.90007 21.6664 9.4859 21.6664 10.2315C21.6664 10.9638 21.0668 11.563 20.334 11.563H4.90464L10.6189 17.2733C11.1386 17.7793 11.1386 18.6314 10.6189 19.1507H10.6056C10.3525 19.3903 10.0061 19.5368 9.65965 19.5368L9.6743 19.5514C9.31457 19.5514 8.96815 19.405 8.72833 19.1653L0.734184 11.1767C0.733322 11.1758 0.732462 11.1749 0.731603 11.1741Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.fdd76e214810fbcd13544256ac0842c7.svg";
export { ForwardRef as ReactComponent };